"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MqttInfo = void 0;
class MqttInfo {
    constructor(opts) {
        this.getReceivePath = () => this.receivePath;
        this.getSendPath = () => this.sendPath;
        this.getUrl = () => __awaiter(this, void 0, void 0, function* () {
            const now = new Date();
            if ((this.currentInfo.expirationTime.getTime() - now.getTime()) <= 0) {
                yield this.fetchNewMqttInfo();
            }
            return this.currentInfo.url;
        });
        this.fetchNewMqttInfo = () => __awaiter(this, void 0, void 0, function* () {
            const refreshedProfile = yield this.profileRefresh();
            this.currentInfo = Object.assign({}, refreshedProfile.mesh.mqttURLInfo);
        });
        const { receivePath, sendPath, profileRefresh, currentInfo, } = opts;
        this.profileRefresh = profileRefresh;
        this.currentInfo = currentInfo;
        this.receivePath = receivePath;
        this.sendPath = sendPath;
    }
}
exports.MqttInfo = MqttInfo;
//# sourceMappingURL=MqttInfoHandler.js.map